import { ColumnModal } from "@/components";
import { useTranslate } from "@/providers/context";

interface UnsavedChangesModalProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  onConfirm?: () => void; // Complete the modal
  onCancel?: () => void; // Cancel the modal
}

export const UnsavedChangesModal = ({ ...props }: UnsavedChangesModalProps) => {
  const { translate } = useTranslate();
  return (
    <ColumnModal
      hideTrigger
      cols={3}
      {...props}
      title={translate("Unsaved Changes")}
      contentClassName="px-6"
      primaryText={translate("Proceed")}
      secondaryText={translate("Cancel")}
    >
      <p className="p1-regular pb-6">
        {translate(
          "Are you sure you want to proceed without saving? Your changes will be lost.",
        )}
      </p>
    </ColumnModal>
  );
};
